export enum SyncPlan {
  ATTRIBUTE_SYNC_PLAN = 'attributeSyncPlan',
  AUTODESK_LAYER_SYNC_PLAN = 'autodeskLayerSyncPlan',
  BLOCK_SYNC_PLAN = 'blockSyncPlan',
  CIVIL3D_PROPERTY_SET_SYNC_PLAN = 'civil3dPropertySetSyncPlan',
  CIVIL3D_PROPERTY_SYNC_PLAN = 'civil3dPropertySyncPlan',
  LINE_STYLE_SYNC_PLAN = 'lineStyleSyncPlan',
  NODE_SYNC_PLAN = 'nodeSyncPlan',
  PLOT_STYLE_SYNC_PLAN = 'plotStyleSyncPlan',
  POINT_LABEL_STYLE_SYNC_PLAN = 'pointLabelStyleSyncPlan',
  POINT_STYLE_SYNC_PLAN = 'pointStyleSyncPlan',
  SYMBOL_SYNC_PLAN = 'symbolSyncPlan',
  TEMPLATE_SYNC_PLAN = 'templateSyncPlan',
  TRIMBLE_LAYER_SYNC_PLAN = 'trimbleLayerSyncPlan',
}

export enum SyncTemplatePlanStatus {
  NEW = 'New',
  REPLACE = 'Replace',
  REMOVED = 'Removed',
}

export enum SyncPlanStatus {
  INVALID = 'invalid',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}
